import { MCPServersEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

const createMCPServers = async (data: any): Promise<any> =>
  APIManager.sendPost(MCPServersEnds.CREATE, data, true, {}, {}, axios);

const getMCPServers = async (queryString: string): Promise<any> =>
  APIManager.sendGet(MCPServersEnds.GET_ALL(queryString), true, {}, {}, axios);

const getDetailsServer = async (id: string): Promise<any> =>
  APIManager.sendGet(MCPServersEnds.GET_DETAILS(id), true, {}, {}, axios);

const updateMCPServerApproveStatus = async (id: any, data: any): Promise<any> =>
  APIManager.sendPut(
    MCPServersEnds.UPDATE_APPROVE_STATUS(id),
    data,
    true,
    {},
    {},
    axios
  );

const updateMCPServer = async (id: any, data: any): Promise<any> =>
  APIManager.sendPut(MCPServersEnds.UPDATE(id), data, true, {}, {}, axios);

const deleteMCPServer = async (id: string): Promise<any> =>
  APIManager.sendDelete(MCPServersEnds.DELETE_SERVER(id), true, {}, {}, axios);

export const MCPServersService = {
  createMCPServers,
  getMCPServers,
  getDetailsServer,
  updateMCPServerApproveStatus,
  deleteMCPServer,
  updateMCPServer,
};
